module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAAAXNSR0IArs4c6QAAATFJREFUKBWNkjFLQmEUhv1uYtJgCCH9Ax3CEPoBLYI4NDVZDjr0B9z6DUFROCYErW0JQg0OLRFuLs6CS4M2WsTtOZdzucfLFTvweM77nvMdvvthKrUhfN8vwwd8wQNkoaL6npxJXEHjGC7iTbwx2LiUGYyJmh17xjOiSX1rtBzaQpesR32geqY51IH0OLQtoOSwCzXZc8794r0Gk9HPQHrIolqDqEVFc12cySDNPNxAH4InIR+qbq8sQ8iNrtWskuXz7lQ/csOR1v9OLpxkcY+6wZKs8fapa1CGXZB3e4Mhc0vOFKiP4AX9Q46CZhc+xSGn4Qq+ISmmmCc6+0Q9g3q0LVbRPIdNITfcgZYOLsjO/m3s2j0r1tQZ/BwstC9P4tIq4ukZYxo3E/Qc7x1Otef/AaMKHokARHPeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /src/globals/images/add-people.png
// module id = 1963
// module chunks = 0